import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { Button } from './ui/button';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';

interface UnsavedChangesDialogProps {
  open: boolean;
  onSaveAndContinue: () => Promise<void>;
  onDiscard: () => void;
  onGoBack: () => void;
}

export function UnsavedChangesDialog({
  open,
  onSaveAndContinue,
  onDiscard,
  onGoBack,
}: UnsavedChangesDialogProps) {
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSaveAndContinue();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unsaved Changes</AlertDialogTitle>
          <AlertDialogDescription>
            You have unsaved changes that will be lost if you navigate away. What would you like to do?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex gap-2 sm:justify-between">
          <Button variant="destructive" onClick={onDiscard} disabled={isSaving}>
            Discard Changes
          </Button>
          <div className="flex gap-2">
            <Button variant="outline" onClick={onGoBack} disabled={isSaving}>
              Go Back
            </Button>
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? (
                <>
                  <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                  Saving...
                </>
              ) : (
                'Save & Continue'
              )}
            </Button>
          </div>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
